document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.play').forEach((play) => {

    play.addEventListener('click', (e) => {
      e.preventDefault();
      let href = play.href;

      if (href.match(/youtube\.com/)) {
        let videoId = href.match(/v=(.+?)(&|$)/);
        let time = href.match(/t=(.+?)(&|$)/);
        let url = '';
        if (time) {
          url = `https://www.youtube.com/embed/${videoId[1]}?start=${parseInt(time[1])}`
        } else {
          url = `https://www.youtube.com/embed/${videoId[1]}`
        }

        let embed = `<iframe src="${url}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="width: 100%; aspect-ratio: 16/9;"></iframe>`;
        play.insertAdjacentHTML('beforebegin', embed);
        play.remove();
      }
    });

  });

});
